module.exports = __webpack_public_path__ + "static/media/grass3.de20d725.png";